import { FREE_DROP_WIDGET_POSITION_KEY } from '../constants';
import { FreeDropDrop } from '../models';
import { convertAmount } from './number';

/**
 * @description level (tier) goals of the drop in the player currency, ascending;
 * a tier without player currency config falls back to its campaign currency goal converted by the rate
 */
export const getFreeDropTierGoals = (drop: FreeDropDrop, currencyCode: string, campaignCurrency: string, rate: number): Array<number> => {
  return [...drop.tiers]
    .sort((a, b) => a.goal - b.goal)
    .map(({ freeBets }) => {
      const userCurrencyFreeBet = freeBets.find(({ currency }) => currency === currencyCode);
      if (userCurrencyFreeBet) return userCurrencyFreeBet.goal;
      const campaignCurrencyFreeBet = freeBets.find(({ currency }) => currency === campaignCurrency);
      return campaignCurrencyFreeBet ? convertAmount(campaignCurrencyFreeBet.goalCoinAmount, rate, 0) : 0;
    });
};

/**
 * @description how many levels the collected amount has reached
 */
export const getFreeDropReachedLevel = (amount: number, goals: Array<number>): number => {
  return goals.filter((goal) => amount >= goal).length;
};

/**
 * @description vertical position the player dragged the free drop widget to, as a fraction of its free
 * vertical space (0 - top, 1 - bottom); null when it was never moved.
 * Storage access throws when the launcher is a third-party iframe with blocked storage.
 */
export const getFreeDropWidgetPosition = (): number | null => {
  try {
    const value = localStorage.getItem(FREE_DROP_WIDGET_POSITION_KEY);
    if (value === null) return null;
    const position = Number(value);
    return position >= 0 && position <= 1 ? position : null;
  } catch {
    return null;
  }
};

export const saveFreeDropWidgetPosition = (position: number): void => {
  try {
    localStorage.setItem(FREE_DROP_WIDGET_POSITION_KEY, `${position}`);
  } catch {
    // storage is blocked, the position is kept for this session only
  }
};
